import React, { FC, useState } from "react";
import { Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormCheck, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../../services/Api/api";
import { AppState } from "../../../utils/types";
import { parseApplicationSettingsValues } from "../../../utils/utils";

interface Props {
	appState: AppState;
	handleUpdateApp: (data: ApplicationApi) => void;
}

const CallRecorderFormModalCard: FC<Props> = ({ appState, handleUpdateApp }) => {
	const { t } = useTranslation();
	const form = useForm<ApplicationApi>({
		criteriaMode: "all",
		defaultValues: {
			...appState.app,
			settings: {
				...appState.app.settings,
				...parseApplicationSettingsValues(appState.app.settings || {}),
			},
		},
	});
	const {
		formState,
		formState: { errors },
		register,
		handleSubmit,
		reset,
		setError,
	} = form;
	const [loading, setLoading] = useState<boolean>(false);
	const { addSuccessFlash, addFlash } = useFlash();

	const onSubmit = handleSubmit(async (data: ApplicationApi) => {
		setLoading(true);
		const params: Record<string, any> = { include: "settings" };

		const newData = {
			name: data.name,
			id: appState.app.id,
			settings: data.settings,
		};

		try {
			const res = await api.organization().updateApp(newData, params);
			handleUpdateApp(res);
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
			reset({
				...res,
				settings: parseApplicationSettingsValues(res.settings),
			});
		} catch (e) {
			handleError.form(e, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Card>
			<Card.Body>
				<FormDirty formState={formState} className="app-form" onSubmit={onSubmit}>
					<FormInput label={t("lib:common.word.name")} register={register} name="name" errors={errors} />
					<FormCheck
						register={register}
						name="settings.persist_outgoing_calls"
						type="switch"
						errors={errors}
						label={t("modules.app.field.persist_outgoing_calls.title")}
					/>
					<FormCheck
						register={register}
						name="settings.persist_missed_calls"
						type="switch"
						errors={errors}
						label={t("modules.app.field.persist_missed_calls.title")}
					/>
					<ButtonLoading loading={loading} variant="add" onClick={onSubmit}>
						{t("common.action.save", { ns: "lib" })}
					</ButtonLoading>
				</FormDirty>
			</Card.Body>
		</Card>
	);
};

export default CallRecorderFormModalCard;
